module.exports = __webpack_public_path__ + "img/bri.5478ca19.png";